import { registerComponent } from "helpers";
import { WYATTElement } from "wyatt";

registerComponent(
  "mobile-nav-item",
  class MobileNavItem extends WYATTElement {
    constructor() {
      super();

      this.forwardButton = this.querySelector("[data-forward]");
      this.backButton = this.querySelector("[data-back]");
      this.menu = this.querySelector(
        `#${this.forwardButton?.getAttribute("aria-controls")}`,
      );

      this.forwardButton?.addEventListener("click", this.goForward.bind(this));
      this.backButton?.addEventListener("click", this.goBack.bind(this));
    }

    goBack(event) {
      event.preventDefault();

      this.menu.setAttribute("aria-expanded", false);
      this.forwardButton.setAttribute("aria-expanded", false);
      this.backButton.setAttribute("aria-expanded", false);
    }

    goForward(event) {
      event.preventDefault();

      this.menu.setAttribute("aria-expanded", true);
      this.forwardButton.setAttribute("aria-expanded", true);
      this.backButton.setAttribute("aria-expanded", true);
    }
  },
);
